module.exports = __webpack_public_path__ + "img/logo.f041b039.png";